export const PHONE_CHANNEL_SETTINGS_TITLE = "Voice Settings";

export const PHONE_CHANNEL_SETTINGS_TABS = {
  GENERAL: "General",
  TELEPHONY: "Telephony",
  ADVANCED: "Advanced",
  PRONUNCIATION: "Pronunciation"
};

export const PHONE_CHANNEL_GENERAL_TAB_SECTIONS = {
  CONFIGURATION_ID: {
    TITLE: "Configuration ID",
  },
  PRIMARY_LANGUAGE: {
    TITLE: "Primary Language",
  },
  SECONDARY_LANGUAGES: {
    TITLE: "Secondary Language",
  }
};
export const PHONE_CHANNEL_TELEPHONY_TAB_SECTIONS = {
  TWILIO: {
    TITLE: "General",
    FIELDS: {
      TWILIO_ACCOUNT: {
        TITLE: "Assigned Twilio Account",
        PLACEHOLDER: "Sub Account Id",
      }
    }
  },
  VOICE_PREFERENCES: {
    TITLE: "Voice Preferences",
    FIELDS: {
      AGENT_VOICE: {
        TITLE: "Agent's voice preferences"
      },
      VOICE_PREVIEW: {
        TITLE: "Agent's voice preview",
        SUBTITLE: "Enter custom text to test your agent's voice preferences"
      }
    }
  },
  EARCON_PREFERENCES: {
    TITLE: "Earcon Settings",
    FIELDS: {
      TYPE: {
        TITLE: "Sound type",
        PLACEHOLDER: "Select a sound"
      },
      VOLUME: {
        TITLE: "Volume",
        PLACEHOLDER: "Select a volume"
      },
      PREVIEW: {
        TITLE: "Earcon preview",
        SUBTITLE: "Preview the selected earcon sound"
      }
    }
  },
  PHONE_MANAGEMENT: {
    TITLE: "Phone Management",
    FIELDS: {
      TELEPHONY: {
        TITLE: "Telephony integration method",
      },
      PHONE_NUMBERS: {
        TITLE: "Phone Numbers",
        PLACEHOLDER: "Enter phone number",
      }
    }
  }
};

export const PHONE_CHANNEL_ADVANCED_TAB_SECTIONS = {
  USER_UTTERANCE_RECORDING: "User Utterance Recording",
  RECORD_ON_TRANSFER: "Record on Transfer",
  REDACT_RECORDINGS: "Redact Recordings",
  TOOLTIP: "Note: when speech redaction is enabled, record on transfer will be disabled automatically."
};

// These names should be corresponding to the names we receive from the backend
export const PHONE_CHANNEL_TELEPHONY_TAB_FIELDS = {
  subAccountId: "subAccountId",
  voiceName: "voiceName",
  speakingRate: "speakingRate",
  pitch: "pitch",
  phoneNumbers: "phoneNumbers",
  proactivePhoneNumber: "proactivePhoneNumber",
  earconType: "earconType",
  earconVolume: "earconVolume",
};

export const PHONE_CHANNEL_ADVANCED_TAB_FIELDS = {
  userUtteranceRecording: "userUtteranceRecording",
  recordOnTransfer: "recordOnTransfer",
  shouldRedact: "shouldRedact"
};

export const PHONE_CHANNEL_GENERAL_TAB_FIELDS = {
  languages: "languages"
};

export const VOICE_PREVIEW_TEXT = "Hi there, and thank you for calling Hyro Health's Upper West Medical Center. We are located at 3600 Broadway, New York, NY, 10025, and are open from 9 AM to 9 PM. I'm your virtual agent. How can I help you today?";

export const VOICE_PREFERENCES_FEATURE_FLAGS = {
  SHOW_ALL_VOICE_OPTIONS: "showAllVoiceOptions"
};
